import { isPeriodIncludeByDate, type Period } from './Period'

function genCell(date: Date, add: number, step: number) {
	return {
		from: addMinutes(date, add),
		to: addMinutes(date, add + step),
	};
}

export type Cell = ReturnType<typeof genCell>;
export type SlotDate = { from: Date, to: Date };

interface GenCellsInterface {
	periods: Period[];
	step: number;
	date: Date,
}

export function genCells({ periods, step, date }: GenCellsInterface) {
	const cells: Cell[] = []
	periods.filter(period => isPeriodIncludeByDate(period, date)).forEach(period => {
		for (let time = period.start; time < period.end; time += step) {
			if (time + step <= period.end) cells.push(genCell(date, time, step));
		}
	})
	return cells;
}
